// Config
import localeConfig from '../config/locale-config.js'

// Contents
import contents, { LocaleContents } from '../contents/contents'

function getContentsByLocale(locale: string): LocaleContents {
    if (!locale) throw new Error('locale is mandatory in getContentsByLocale')
    if (!localeConfig.has(locale)) throw new Error('invalid locale, does not exist in localeConfig in getContentsByLocale')

    return contents[locale]
}

export default getContentsByLocale
